"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCreator = void 0;
var analytics_layer_1 = require("@pmi/analytics-layer");
var socialInteraction_1 = require("./socialInteraction");
var creatorMappings = (_a = {},
    _a[analytics_layer_1.SocialEventNames.SocialInteraction] = socialInteraction_1.socialInteraction,
    _a);
var getCreator = function (eventName) { return creatorMappings[eventName]; };
exports.getCreator = getCreator;
